/* ================================================================
   SURE-GOLF PDP — interactions
   Scroll reveals · sticky add-to-cart · gallery · FAQ · video play
   No dependencies. Safe to drop into a Shopify section.
   ================================================================ */
(function () {
  "use strict";
  if (window.__hdz2PDPInit) { return; }
  window.__hdz2PDPInit = true;

  // Land at the top on a fresh load; stop the browser from restoring an old
  // scroll position (which looked like the page "scrolling down by itself").
  if ("scrollRestoration" in history) { history.scrollRestoration = "manual"; }

  /* ---- Scroll reveal ---------------------------------------- */
  var reveals = document.querySelectorAll("[data-reveal]");
  if ("IntersectionObserver" in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add("in"); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: "0px 0px -8% 0px" });
    reveals.forEach(function (el) { io.observe(el); });
    // Reveal the first screenful immediately — don't wait for a scroll (some
    // mobile browsers delay the observer's first callback, leaving blank space).
    var revealInView = function () {
      var vh = window.innerHeight || document.documentElement.clientHeight;
      reveals.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh * 1.15 && r.bottom > 0) { el.classList.add("in"); io.unobserve(el); }
      });
    };
    revealInView();
    window.addEventListener("load", revealInView);
  } else {
    reveals.forEach(function (el) { el.classList.add("in"); });
  }

  /* ---- Product gallery (per .gallery container) ------------- */
  function animateScroll(el, to, dur) {
    to = Math.max(0, Math.min(to, el.scrollWidth - el.clientWidth));
    var from = el.scrollLeft, d = to - from, start = null;
    if (Math.abs(d) < 1) return;
    function step(ts) {
      if (start === null) start = ts;
      var t = Math.min(1, (ts - start) / dur);
      var e = t < 0.5 ? 2 * t * t : 1 - Math.pow(-2 * t + 2, 2) / 2;
      el.scrollLeft = from + d * e;
      if (t < 1) requestAnimationFrame(step);
    }
    requestAnimationFrame(step);
  }
  document.querySelectorAll(".gallery").forEach(function (gal) {
    var mainImg = gal.querySelector("[data-gallery-main]");
    var thumbs = Array.prototype.slice.call(gal.querySelectorAll("[data-gallery-thumb]"));
    var galIndex = 0;
    function showGallery(i) {
      if (!thumbs.length) return;
      galIndex = (i + thumbs.length) % thumbs.length;
      var btn = thumbs[galIndex];
      var src = btn.getAttribute("data-src");
      if (mainImg && src) {
        mainImg.style.opacity = "0";
        setTimeout(function () { mainImg.src = src; mainImg.style.opacity = "1"; }, 120);
      }
      thumbs.forEach(function (b) { b.classList.remove("active"); });
      btn.classList.add("active");
      var strip = btn.parentNode;
      if (strip && strip.scrollWidth > strip.clientWidth) {
        var sRect = strip.getBoundingClientRect();
        var bRect = btn.getBoundingClientRect();
        var delta = (bRect.left - sRect.left) - (strip.clientWidth - bRect.width) / 2;
        animateScroll(strip, strip.scrollLeft + delta, 320);
      }
    }
    thumbs.forEach(function (btn, i) {
      btn.addEventListener("click", function () { showGallery(i); });
    });
    var prevBtn = gal.querySelector("[data-gallery-prev]");
    var nextBtn = gal.querySelector("[data-gallery-next]");
    if (prevBtn) prevBtn.addEventListener("click", function () { showGallery(galIndex - 1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { showGallery(galIndex + 1); });
    var gMain = gal.querySelector(".gallery__main");
    if (gMain) {
      var startX = 0, startY = 0, touching = false;
      gMain.addEventListener("touchstart", function (e) {
        var t = e.changedTouches[0]; startX = t.clientX; startY = t.clientY; touching = true;
      }, { passive: true });
      gMain.addEventListener("touchend", function (e) {
        if (!touching) return; touching = false;
        var t = e.changedTouches[0], dx = t.clientX - startX, dy = t.clientY - startY;
        if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) {
          showGallery(dx < 0 ? galIndex + 1 : galIndex - 1);
        }
      }, { passive: true });
    }
  });

  /* ---- FAQ accordion ---------------------------------------- */
  document.querySelectorAll("[data-faq]").forEach(function (item) {
    var q = item.querySelector(".faq__q");
    var a = item.querySelector(".faq__a");
    if (!q || !a) return;
    q.addEventListener("click", function () {
      var open = item.classList.contains("open");
      // single-open: collapse every other open item in the same FAQ group
      var group = item.closest(".faq") || document;
      group.querySelectorAll("[data-faq].open").forEach(function (other) {
        if (other === item) return;
        other.classList.remove("open");
        var oa = other.querySelector(".faq__a"), oq = other.querySelector(".faq__q");
        if (oa) oa.style.maxHeight = null;
        if (oq) oq.setAttribute("aria-expanded", "false");
      });
      if (open) { a.style.maxHeight = null; item.classList.remove("open"); q.setAttribute("aria-expanded", "false"); }
      else { item.classList.add("open"); a.style.maxHeight = a.scrollHeight + "px"; q.setAttribute("aria-expanded", "true"); }
    });
  });

  /* ---- Creators peek carousel (loop) ------------------------ */
  document.querySelectorAll("[data-cr]").forEach(function (root) {
    var vp = root.querySelector(".cr__vp");
    var track = root.querySelector("[data-cr-track]");
    var originals = Array.prototype.slice.call(track.children);
    var N = originals.length;
    if (!N) return;
    var gap = 14;
    // triple the cards for an infinite loop
    var pre = originals.map(function (c) { return c.cloneNode(true); });
    var post = originals.map(function (c) { return c.cloneNode(true); });
    track.innerHTML = "";
    pre.concat(originals, post).forEach(function (c) { track.appendChild(c); });
    var cards = Array.prototype.slice.call(track.children);
    var index = N;            // first real card
    var cardW = 220, step = 234, offset = 0, animating = false;

    // pagination dots (one per original card)
    var dots = [];
    var dotsWrap = document.createElement("div");
    dotsWrap.className = "cr__dots";
    for (var di = 0; di < N; di++) {
      var dot = document.createElement("button");
      dot.className = "cr__dot" + (di === 0 ? " on" : "");
      dot.type = "button";
      dot.setAttribute("aria-label", "Go to slide " + (di + 1));
      (function (target) { dot.addEventListener("click", function () { goTo(target); }); })(di);
      dotsWrap.appendChild(dot);
      dots.push(dot);
    }
    root.appendChild(dotsWrap);
    function curPos() { return ((index % N) + N) % N; }
    function updateDots() { var p = curPos(); for (var k = 0; k < dots.length; k++) { dots[k].classList.toggle("on", k === p); } }
    function goTo(target) {
      if (animating) return;
      var delta = target - curPos();
      if (!delta) return;
      animating = true; index += delta; updateDots(); position(true);
      setTimeout(function () { if (animating) settle(); }, 540);
    }

    function fullVisible() {
      var W = vp.clientWidth;
      if (W >= 1000) return 3;
      if (W >= 620) return 2;
      return 1;
    }
    function layout() {
      var W = vp.clientWidth;
      if (!W) { setTimeout(layout, 150); return; }   // viewport has no width yet — retry
      var fv = fullVisible();
      if (fv === 1) {                     // mobile: 1 full card + ~25% peek of the next on the right
        cardW = Math.round((W - gap) / 1.25);
      } else {                            // tablet/desktop: full cards + two half peeks
        cardW = Math.round((W - gap) / (fv + 1));
      }
      step = cardW + gap;
      var cardH = Math.round(cardW * 16 / 9); // explicit height: every .creator child is
      cards.forEach(function (c) {            // position:absolute, so don't depend on aspect-ratio
        c.style.width = cardW + "px";
        c.style.height = cardH + "px";
        c.style.marginRight = gap + "px";
      });
      if (fv === 1) {
        offset = 0;                       // first card flush-left, next peeks on the right
      } else {
        var block = fv * step - gap;      // width of the fully-visible block
        offset = Math.round((W - block) / 2);
      }
      position(false);
    }
    function position(animate) {
      track.style.transition = animate ? "transform .42s cubic-bezier(.4,0,.2,1)" : "none";
      track.style.transform = "translateX(" + (offset - index * step) + "px)";
    }
    function go(dir) {
      if (animating) return;
      animating = true;
      index += dir;
      updateDots();
      position(true);
      setTimeout(function () { if (animating) settle(); }, 540); // safety if transitionend misses
    }
    function settle() {
      animating = false;
      if (index >= 2 * N) { index -= N; position(false); }
      else if (index < N) { index += N; position(false); }
      updateDots();
    }
    track.addEventListener("transitionend", function (e) {
      if (e.propertyName === "transform") settle();
    });
    var prevBtn = root.querySelector("[data-cr-prev]");
    var nextBtn = root.querySelector("[data-cr-next]");
    if (prevBtn) prevBtn.addEventListener("click", function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener("click", function () { go(1); });

    /* ---- drag / swipe to slide ---- */
    var dragging = false, startX = 0, baseTx = 0, didDrag = false;
    function curTx() { return offset - index * step; }
    track.addEventListener("pointerdown", function (e) {
      if (animating) return;
      dragging = true; didDrag = false; startX = e.clientX; baseTx = curTx();
    });
    track.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      var dx = e.clientX - startX;
      if (!didDrag && Math.abs(dx) > 8) { didDrag = true; track.style.transition = "none"; }
      if (didDrag) track.style.transform = "translateX(" + (baseTx + dx) + "px)";
    });
    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      if (!didDrag) return;                 // a tap — leave it for the click handler
      var dx = (e.clientX || startX) - startX;
      var steps = Math.round(-dx / step);
      if (steps === 0 && Math.abs(dx) > step * 0.18) steps = dx < 0 ? 1 : -1;
      index += steps;
      updateDots();
      animating = true;
      position(true);
      setTimeout(function () { if (animating) settle(); }, 540);
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);

    /* ---- play -> full-screen native player ---- */
    function openPlayer(src) {
      var clean = src.split("#")[0];
      var ov = document.createElement("div");
      ov.className = "cr-modal";
      ov.innerHTML =
        '<button class="cr-modal__x" aria-label="Close video"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18 6 6 18M6 6l12 12" stroke="currentColor" stroke-width="2" fill="none" stroke-linecap="round"/></svg></button>' +
        '<video class="cr-modal__v" src="' + clean + '" controls autoplay playsinline></video>';
      document.body.appendChild(ov);
      document.body.style.overflow = "hidden";
      function close() {
        var v = ov.querySelector("video"); if (v) { v.pause(); }
        ov.remove();
        document.body.style.overflow = "";
        document.removeEventListener("keydown", onKey);
      }
      ov.addEventListener("click", function (e) {
        if (e.target === ov || e.target.closest(".cr-modal__x")) close();
      });
      function onKey(e) { if (e.key === "Escape") close(); }
      document.addEventListener("keydown", onKey);
    }
    track.addEventListener("click", function (e) {
      if (didDrag) { didDrag = false; return; }         // ignore click that ended a drag
      var card = e.target.closest(".creator");
      if (!card) return;
      var v = card.querySelector("video");
      if (!v) return;
      openPlayer(v.getAttribute("src") || v.src);
    });

    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(layout, 120); }, { passive: true });
    window.addEventListener("load", layout);          // re-measure once everything has rendered
    if ("ResizeObserver" in window) { new ResizeObserver(layout).observe(vp); } // re-measure when it first gets a width
    layout();
  });

  /* ---- In Action — crossfade slideshow (image-over-image, ~0.5s) -------- */
  document.querySelectorAll(".actionslide").forEach(function (slide) {
    var imgs = slide.querySelectorAll("img");
    if (imgs.length < 2) return;
    // only the first frame starts visible — the rest sit at opacity 0 so each
    // incoming frame genuinely transitions 0 -> 1 (a real cross-fade, not a hard cut)
    for (var i = 0; i < imgs.length; i++) { imgs[i].style.opacity = (i === 0 ? "1" : "0"); imgs[i].style.zIndex = (i === 0 ? "2" : "1"); }
    if (window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches) return;
    var cur = 0;
    setInterval(function () {
      var nxt = (cur + 1) % imgs.length, prev = cur;
      imgs[nxt].style.zIndex = "3";        // incoming on top
      imgs[nxt].style.opacity = "1";       // fades 0 -> 1 over the current (which stays opaque) — no white gap
      setTimeout(function () {
        imgs[prev].style.opacity = "0";    // hide the now-covered previous frame
        imgs[prev].style.zIndex = "1";
        imgs[nxt].style.zIndex = "2";
      }, 560);
      cur = nxt;
    }, 2600);
  });

  /* ---- Soft by Design — looping card carousel + dots ---- */
  document.querySelectorAll("[data-softcar]").forEach(function (root) {
    var vp = root.querySelector(".softcar__vp");
    var track = root.querySelector(".softcar__track");
    var originals = Array.prototype.slice.call(track.children);
    var N = originals.length;
    if (!N) return;
    var gap = 14;
    var pre = originals.map(function (c) { return c.cloneNode(true); });
    var post = originals.map(function (c) { return c.cloneNode(true); });
    track.innerHTML = "";
    pre.concat(originals, post).forEach(function (c) { track.appendChild(c); });
    var cards = Array.prototype.slice.call(track.children);
    var index = N, cardW = 280, step = 294, offset = 0, animating = false;
    var dots = [], dotsWrap = root.querySelector(".softcar__dots");
    for (var di = 0; di < N; di++) {
      var d = document.createElement("button");
      d.type = "button"; d.className = "softcar__dot" + (di === 0 ? " on" : "");
      d.setAttribute("aria-label", "Slide " + (di + 1));
      (function (t) { d.addEventListener("click", function () { goTo(t); }); })(di);
      dotsWrap.appendChild(d); dots.push(d);
    }
    function curPos() { return ((index % N) + N) % N; }
    function updateDots() { var p = curPos(); for (var k = 0; k < dots.length; k++) { dots[k].classList.toggle("on", k === p); } }
    function fv() { var W = vp.clientWidth; return W >= 760 ? 3 : (W >= 520 ? 2 : 1); }
    function layout() {
      var W = vp.clientWidth;
      if (!W) { setTimeout(layout, 150); return; }
      var n = fv();
      cardW = n === 1 ? Math.round((W - gap) / 1.18) : Math.round((W - gap * n) / n);
      step = cardW + gap;
      cards.forEach(function (c) { c.style.width = cardW + "px"; c.style.marginRight = gap + "px"; });
      offset = 0;
      position(false);
    }
    function position(animate) {
      track.style.transition = animate ? "transform .45s cubic-bezier(.4,0,.2,1)" : "none";
      track.style.transform = "translateX(" + (offset - index * step) + "px)";
    }
    function settle() {
      animating = false;
      if (index >= 2 * N) { index -= N; position(false); }
      else if (index < N) { index += N; position(false); }
      updateDots();
    }
    function go(dir) { if (animating) return; animating = true; index += dir; updateDots(); position(true); setTimeout(function () { if (animating) settle(); }, 560); }
    function goTo(t) { if (animating) return; var delta = t - curPos(); if (!delta) return; animating = true; index += delta; updateDots(); position(true); setTimeout(function () { if (animating) settle(); }, 560); }
    track.addEventListener("transitionend", function (e) { if (e.propertyName === "transform") settle(); });
    var dragging = false, startX = 0, baseTx = 0, didDrag = false;
    track.addEventListener("pointerdown", function (e) { if (animating) return; dragging = true; didDrag = false; startX = e.clientX; baseTx = offset - index * step; });
    track.addEventListener("pointermove", function (e) { if (!dragging) return; var dx = e.clientX - startX; if (!didDrag && Math.abs(dx) > 8) { didDrag = true; track.style.transition = "none"; } if (didDrag) track.style.transform = "translateX(" + (baseTx + dx) + "px)"; });
    function endDrag(e) { if (!dragging) return; dragging = false; if (!didDrag) return; var dx = (e.clientX || startX) - startX; var steps = Math.round(-dx / step); if (steps === 0 && Math.abs(dx) > step * 0.18) steps = dx < 0 ? 1 : -1; index += steps; updateDots(); animating = true; position(true); setTimeout(function () { if (animating) settle(); }, 560); }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    var auto;
    function startAuto() { clearInterval(auto); if (window.matchMedia && window.matchMedia("(prefers-reduced-motion:reduce)").matches) return; auto = setInterval(function () { if (!animating && !dragging) go(1); }, 3600); }
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(layout, 120); }, { passive: true });
    window.addEventListener("load", layout);
    if ("ResizeObserver" in window) { new ResizeObserver(layout).observe(vp); }
    layout(); startAuto();
  });

  /* ---- Reviews — single-card snap rail with synced dots ---- */
  document.querySelectorAll("[data-revrail]").forEach(function (rail) {
    var cards = Array.prototype.slice.call(rail.children);
    var N = cards.length;
    if (!N) return;
    var dotsWrap = (rail.parentNode || rail).querySelector(".reviews__dots");
    if (!dotsWrap) return;
    var dots = [];
    cards.forEach(function (card, i) {
      var d = document.createElement("button");
      d.type = "button"; d.className = "reviews__dot" + (i === 0 ? " on" : "");
      d.setAttribute("aria-label", "Review " + (i + 1));
      d.addEventListener("click", function () {
        var target = card.offsetLeft - (rail.clientWidth - card.clientWidth) / 2;
        rail.scrollTo({ left: target, behavior: "smooth" });
      });
      dotsWrap.appendChild(d); dots.push(d);
    });
    var raf;
    rail.addEventListener("scroll", function () {
      if (raf) cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        var center = rail.scrollLeft + rail.clientWidth / 2, best = 0, bestDist = Infinity;
        cards.forEach(function (c, i) {
          var cc = c.offsetLeft + c.offsetWidth / 2, dist = Math.abs(cc - center);
          if (dist < bestDist) { bestDist = dist; best = i; }
        });
        for (var k = 0; k < dots.length; k++) { dots[k].classList.toggle("on", k === best); }
      });
    }, { passive: true });
  });

  /* ---- Autoplay videos (e.g. "Every Club") — nudge play when in view ----
     Mobile blocks autoplay until a muted/inline video is actually told to play
     while visible; we also retry once it scrolls into view. ----------------- */
  (function () {
    var vids = document.querySelectorAll("video[autoplay]");
    if (!vids.length) return;
    var tryPlay = function (v) {
      v.muted = true; v.setAttribute("muted", "");
      var p = v.play();
      if (p && p.catch) { p.catch(function () {}); } // ignore block (frame stays as poster)
    };
    if ("IntersectionObserver" in window) {
      var vio = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) { tryPlay(e.target); } });
      }, { threshold: 0.25 });
      vids.forEach(function (v) { vio.observe(v); });
    } else {
      vids.forEach(tryPlay);
    }
  })();

  /* ---- Sticky add-to-cart ----------------------------------- */
  var bar = document.querySelector("[data-stickybar]");
  var heroCta = document.querySelector("[data-hero-cta]");
  var ticker = document.querySelector(".press-marquee");
  var finalCtas = document.querySelectorAll("[data-final-cta]");
  var finalCta = finalCtas.length ? finalCtas[finalCtas.length - 1] : null; // last = bottom buy box
  if (bar) {
    var evaluate = function () {
      var vh = window.innerHeight;
      // hero CTA scrolled above the viewport; if no hero section is present, fall back to ~one screen scrolled
      // floating cart appears once the press ticker has scrolled out of view
      var passed = ticker ? ticker.getBoundingClientRect().bottom < 0
                 : heroCta ? heroCta.getBoundingClientRect().bottom < 0
                 : window.pageYOffset > vh * 0.6;
      var atFinal = finalCta ? finalCta.getBoundingClientRect().top < vh - 80 : false; // final CTA in view
      bar.classList.toggle("show", passed && !atFinal);
    };
    window.addEventListener("scroll", evaluate, { passive: true });
    window.addEventListener("resize", evaluate, { passive: true });
    evaluate();

    /* sticky CTA -> smooth-scroll to the main buy box (#hero, else first .hero) */
    var barLink = bar.querySelector('a[href^="#"]');
    if (barLink) {
      barLink.addEventListener("click", function (e) {
        var id = barLink.getAttribute("href").slice(1);
        var target = document.getElementById(id) || document.querySelector(".hero");
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      });
    }
  }

  /* ---- Buy-box add-to-cart: instant feedback ------------------------------
     Kaching intercepts the click and adds the bundle via its own AJAX (then
     Upcart opens) — that round-trip is ~1.5s of Kaching's server, not ours.
     We can't speed its backend, but we give immediate feedback on press so the
     wait reads as "adding…", not "frozen". No preventDefault/disable, so we
     never block Kaching's own click handling. ------------------------------- */
  document.querySelectorAll("button[data-hero-cta], button[data-final-cta]").forEach(function (btn) {
    btn.addEventListener("pointerdown", function () {
      var label = btn.querySelector(".lbl");
      if (!label || btn.classList.contains("is-loading")) return;
      var prev = label.textContent;
      btn.classList.add("is-loading");
      label.textContent = "Adding…";
      setTimeout(function () { btn.classList.remove("is-loading"); label.textContent = prev; }, 2500);
    });
  });

  /* ---- In-page CTAs (e.g. bottom buy box "Choose Your Kit") -> smooth-scroll ---- */
  document.querySelectorAll("a[data-hdz1-scroll]").forEach(function (link) {
    link.addEventListener("click", function (e) {
      var id = (link.getAttribute("href") || "").slice(1);
      var target = (id && document.getElementById(id)) || document.querySelector(".hero");
      if (target) { e.preventDefault(); target.scrollIntoView({ behavior: "smooth", block: "start" }); }
    });
  });
})();
